var React = require('react');

function Moon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.7 27c4.2 0 8.1-2.4 9.8-6.2-1.1.5-2.3.7-3.5.7-4.8 0-8.6-3.9-8.6-8.6 0-3.2 1.8-6.2 4.7-7.7-.9-.2-1.7-.2-2.4-.2-6.1 0-11 4.9-11 11s4.9 11 11 11z"}));
}

Moon.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Moon;

Moon.default = Moon;
